import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompCodeEditorComponent } from './comp-code-editor.component';
import { CodeEditorModule, MonacoCodeEditorConfig } from '@farris/ide-code-editor';
import { ComponentCodeService } from './service/component-code.service';
import { NotifyModule } from '@farris/ui-notify';
import { GSPMetadataRTService, GSPMetadataRTServiceModule } from '@gsp-lcm/metadatart-selector';
import { MessageNotifyService } from './service/message-notify.service';
import { GSPMetadataService, GSPMetadataServiceModule } from '@gsp-lcm/metadata-selector';
import { MessagerModule, MessagerService } from '@farris/ui-messager';
import { LoadingModule } from '@farris/ui-loading';

const monacoCodeEditorConfig: MonacoCodeEditorConfig = {
  baseUrl: '/platform/common/web/assets/monaco'
};

@NgModule({
  declarations: [CompCodeEditorComponent],
  imports: [
    CommonModule,
    CodeEditorModule.forRoot(monacoCodeEditorConfig),
    NotifyModule.forRoot(),
    GSPMetadataRTServiceModule.forRoot(''),
    GSPMetadataServiceModule.forRoot(''),
    MessagerModule.forRoot(),
    LoadingModule.forRoot()
  ],
  exports: [
    CompCodeEditorComponent
  ],
  providers: [
    ComponentCodeService,
    MessageNotifyService,
    GSPMetadataService,
    GSPMetadataRTService,
    MessagerService
  ]
})
export class CompCodeEditorModule {
}
